/* localStorage wrapper/helper functions; useful for error handling and proper type casting */
export const getLocalStorageItem = (key) => {
  try {
    const value = localStorage.getItem(key);
    if (!value || value === 'null' || value === 'undefined' || value === 'false') {
      removeLocalStorageItem(key);
      return undefined;
    } else if (value === 'true') {
      return true;
    } else {
      return value;
    }
  } catch (error) {
    console.error(error);
  }
};

export const setLocalStorageItem = (key, value) => {
  try {
    if (!value || value === 'null' || value === 'undefined' || value === 'false') {
      removeLocalStorageItem(key);
    } else {
      return localStorage.setItem(key, value);
    }
  } catch (error) {
    console.error(error);
  }
};

export const removeLocalStorageItem = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(error);
  }
};

export const clearLocalStorage = () => {
  try {
    return localStorage.clear();
  } catch (error) {
    console.error(error);
  }
};
